<div class="wrapper--switch">
  <label *ngIf="label" class="label">{{ label }}</label>
  <div
    class="switch"
    [class.checked]="checked"
    [class.disabled]="disabled"
    (click)="toggle()"
  >
    <div class="handle" [class.checked]="checked">
      <ark-icon class="icon" icon="tick" size="tiny" color="confirm"></ark-icon>
    </div>
  </div>
</div>
